import React from 'react'

const EmbedTitle = ({ children }) => {
  return (
    <div className="mt-8 desktop:mt-10 mb-8 desktop:mb-12 font-roboto-flex text-[1.75rem] desktop:text-[2.5rem] text-center uppercase">{children}</div>
  )
}

export default EmbedTitle